class HaanCalculator {

  constructor($elm) {
    this.type = '';
    this.allowedZipCodes = ['42781'];

    this.initDomElements($elm);
    this.initForm();
    this.readType();
    this.updateMainClassByType();
    this.updateHeadlineByType();
    this.initConsumptionByPeople();
    this.toggleMeasuringSystem();
  }

  initDomElements($elm) {
    this.domElements = {};
    this.domElements.main = $elm;
    this.domElements.form = this.domElements.main.find('form');
    this.domElements.submitButton = this.domElements.form.find(
        'button[type="submit"]');
    this.domElements.typeRadios = this.domElements.form.find('.calculator__type-buttons input');
    this.domElements.headline = this.domElements.main.find('.calculator__headline');
    this.domElements.peopleRadios = this.domElements.form.find('.calculator__people-buttons input');
    this.domElements.consumptionInput = this.domElements.form.find('#consumption');
    this.domElements.measuringSystem = this.domElements.form.find('.calculator__measuring-system');
  }

  initForm() {
    this.domElements.form.on('change', this.onChangeForm.bind(this));
  }

  onChangeForm() {
    this.readType();
    this.updateMainClassByType();
    this.updateHeadlineByType();
    this.toggleMeasuringSystem();
  }

  toggleMeasuringSystem() {
    if (this.type === 'electricity') {
      this.domElements.measuringSystem.show();
    } else {
      this.domElements.measuringSystem.hide();
    }
  }

  readType() {
    this.type = this.domElements.typeRadios.filter(':checked').val();
  }

  updateMainClassByType() {
    if (this.type === 'electricity') {
      this.domElements.main.removeClass('calculator--gas');
      this.domElements.main.addClass('calculator--electricity');
    }
    else {
      this.domElements.main.removeClass('calculator--electricity');
      this.domElements.main.addClass('calculator--gas');
    }
  }

  updateHeadlineByType() {
    switch (this.type) {
      case 'electricity':
        this.domElements.headline.text(this.domElements.headline.data('textElectricity'));
        break;
      case 'gas':
        this.domElements.headline.text(this.domElements.headline.data('textGas'));
        break;
    }
  }

  initConsumptionByPeople() {
    this.domElements.peopleRadios.on('change', () => {
      this.setConsumptionValueByPeople();
    });
  }

  setConsumptionValueByPeople() {
    let value;

    switch (this.type) {
      case 'electricity':
        value = this.domElements.peopleRadios.filter(':checked').data('valueElectricity');
        break;
      case 'gas':
        value = this.domElements.peopleRadios.filter(':checked').data('valueGas');
        break;
    }

    this.domElements.consumptionInput.val(value);
  }

  // setInitialType() {
  //   if (this.domElements.main.data(''))
  // }

}

export default HaanCalculator;
